<script setup lang="ts">
import { useGameStore } from "@/stores/games.ts";
import IncrementButton from "@/components/form/IncrementButton.vue";
import TeamDisplay from "@/components/TeamDisplay.vue";

const gameStore = useGameStore();

function save(game_id: string) {
  const game = gameStore.games.find(g => g.id === game_id);
  if (!game) return;
  gameStore.put(game);
}

</script>

<template>
  <div class="page">
    <div class="game-edit panel">
      <h2>Spiele bearbeiten</h2>
      <table>
        <thead>
          <tr>
            <th>NR</th>
            <th>Datum</th>
            <th>Heim</th>
            <th>Gast</th>
            <th>Spielstand</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(game, index) in gameStore.games" :key="game.id">
            <td>#{{ index + 1 }}</td>
            <td>
              {{ new Date(game.dateTime).toLocaleTimeString('de-DE', {
                hour: '2-digit',
                minute: '2-digit',
              }) }}
            </td>
            <td>
              <TeamDisplay :team="game.teams.home" />
            </td>
            <td>
              <TeamDisplay :team="game.teams.away" />
            </td>
            <td>
              <div class="score-display" v-if="game.score">
                <IncrementButton
                  v-model="game.score.home"
                  @click="save(game.id)"
                  :min="0"
                />
                <span>:</span>
                <IncrementButton
                  v-model="game.score.away"
                  @click="save(game.id)"
                  :min="0"
                />
                <div class="reset-score button-like" @click="game.score = null; save(game.id)">
                  Reset
                </div>
              </div>
              <div class="score-display button-like" v-else @click="game.score = { home: 0, away: 0 }; save(game.id)">
                Ergebnis hinzufügen
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped>

.game-edit {
  overflow-x: auto;

  td {
    text-align: center;
    vertical-align: middle;

    input {
      width: 100%;
    }
  }

  .score-display {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
  }

  .button-like {
    cursor: pointer;
    background-color: var(--color-layer-2);
    padding: 0.25rem 0.5rem;
    border-radius: 0.5rem;
  }

  .reset-score {
    writing-mode: vertical-lr;
    padding: 0.5rem 0.25rem;
  }
}

.game-create form {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
